module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field name bold"
  }, [_vm._v(_vm._s(_vm.name))])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.description))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field type",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(("" + (_vm.type.description))))
    }
  })]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field possibleValues"
  }, [_vm._v(_vm._s(_vm.transformedPossibleValues))])]), _c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.order)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.inUse,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.order)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a21cc36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a21cc36"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/attributesSet/attribute.pug
// module id = 1363
// module chunks = 0